function typeOrder(type) {
  const order = {
    query: 0,
    unit: 1,
    monitor: 2,
    trips: 3,
    route: 4,
    travel: 5,
    geo: 6,
    embed_dtc: 7,
    default: 8,
  };
  return Object.prototype.hasOwnProperty.call(order, type)
    ? order[type]
    : order.default;
}

export function createSocketOptions(type) {
  return {
    transports: ["websocket"],
    forceNew: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 700,
    reconnectionDelayMax: 9000,
    randomizationFactor: 0.6,
    timeout: 20000,
    query: { type },
  };
}

export function getHelloDelayMs(type) {
  const order = typeOrder(type);
  const base = order * 120;
  const jitter = Math.floor(Math.random() * 180);
  return base + jitter;
}

export function scheduleHelloWithJitter(type, emitFn) {
  const delay = getHelloDelayMs(type);
  setTimeout(() => {
    try {
      emitFn();
    } catch (_error) {}
  }, delay);
}

export function getWorkerBootstrapDelayMs(type) {
  return typeOrder(type) * 180;
}
